import { DesignSchemesBucket, type DesignSchemesBucketState } from './buckets/DesignSchemesBucket';
import { GlobalBucket, type GlobalBucketState } from './buckets/GlobalBucket';
import { LayersBucket, type LayersBucketState } from './buckets/LayersBucket';

export type { DesignSchemesBucketState } from './buckets/DesignSchemesBucket';
export type { GlobalBucketState } from './buckets/GlobalBucket';
export type { LayersBucketState } from './buckets/LayersBucket';

export const PERSIST_STORE_VERSION = 2;

export type PersistedBuckets = {
    global: GlobalBucketState;
    layers: LayersBucketState;
    designSchemes: DesignSchemesBucketState;
};

export type PersistedBucketVersions = {
    global: number;
    layers: number;
    designSchemes: number;
};

export type PersistedStoreSlice = PersistedBuckets;

export const globalBucket = new GlobalBucket();
export const layersBucket = new LayersBucket();
export const designSchemesBucket = new DesignSchemesBucket();

export const GLOBAL_BUCKET_VERSION = globalBucket.latestVersion;
export const LAYERS_BUCKET_VERSION = layersBucket.latestVersion;
export const DESIGN_SCHEMES_BUCKET_VERSION = designSchemesBucket.latestVersion;

export const getCurrentBucketVersions = (): PersistedBucketVersions => ({
    global: GLOBAL_BUCKET_VERSION,
    layers: LAYERS_BUCKET_VERSION,
    designSchemes: DESIGN_SCHEMES_BUCKET_VERSION,
});

export const getDefaultGlobalBucketState = (): GlobalBucketState => globalBucket.getDefault();
export const getDefaultLayersBucketState = (): LayersBucketState => layersBucket.getDefault();
export const getDefaultDesignSchemesBucketState = (): DesignSchemesBucketState => designSchemesBucket.getDefault();

export const migrateGlobalBucket = (persisted: unknown, version = 0): GlobalBucketState => globalBucket.migrate(persisted, version);
export const migrateLayersBucket = (persisted: unknown, version = 0): LayersBucketState => layersBucket.migrate(persisted, version);
export const migrateDesignSchemesBucket = (persisted: unknown, version = 0): DesignSchemesBucketState =>
    designSchemesBucket.migrate(persisted, version);
